import React, { useContext } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import WellPerformanceStore from "../wellperformance/store/WellPerformanceStore";
import { createContext } from "react";
import moment from "moment";
import { Skeleton } from "antd";
import { Observer } from "mobx-react-lite";

const wellPerformanceStoreCtx = createContext(WellPerformanceStore);

export const OilWellPerformanceChart = () => {
  const wellPerformanceStore = useContext(wellPerformanceStoreCtx);
  const plotData = wellPerformanceStore.plotData || [];
  const getSeriesData = (field) =>
    plotData.map((point) => {
      const value = Number(point?.[field]);
      return Number.isFinite(value) ? value : null;
    });

  return (
    <Observer>
      {() =>
        wellPerformanceStore.isIniatilizing ? (
          <div style={{ padding: "15px" }}>
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
          </div>
        ) : (
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              chart: { zoomType: "xy" },
              credits: { enabled: true, text: "source: SPARS" },
              title: { text: `${wellPerformanceStore.selectedWell} Performance Plot`, align: "center" },
              xAxis: { categories: plotData.map((point) => point?.productionDate ? moment(point.productionDate).format("MM-Y") : ""), crosshair: true },
              yAxis: [
                { gridLineWidth: 0, title: { text: "GasDailyPrd (Mscf/d)" } },
                { title: { text: "OilDailyPrd (bbl/d)" } },
                { gridLineWidth: 0, title: { text: "WaterDailyPrd (bbl/d)" }, opposite: true },
                { gridLineWidth: 0, min: 0, title: { text: "Cum. Oil Prod(bbl)" }, opposite: true },
              ],
              tooltip: { shared: true },
              legend: { layout: "horizontal", align: "center", verticalAlign: "bottom", backgroundColor: "#FFFFFF" },
              series: [
                { name: "OilDailyPrd", type: "areaspline", yAxis: 1, data: getSeriesData("oilRate"), marker: { enabled: false }, color: "#d22d3a" },
                { name: "Water Rate (bbl/d)", type: "spline", yAxis: 2, data: getSeriesData("waterRate"), marker: { enabled: false }, color: "blue" },
                { yAxis: 3, name: "Cum. Oil.Prod", type: "spline", color: "red", data: getSeriesData("cumOil"), marker: { enabled: false } },
                { name: "Gas Rate (Mscf/d)", color: "green", type: "spline", data: getSeriesData("gasRate"), marker: { enabled: false } },
              ],
            }}
          />
        )
      }
    </Observer>
  );
};